<template>
  <div class="page">
    <home-header activeIndex="4" pageTitle="校园Q&A"/>
    <div class="pageWrap">
      <div class="top">
        <div class="back" @click="back"><a-icon type="left" />返回</div>
        <div class="info">
          <div class="tag">Q&A来源：{{detail.qaName}}</div>
          <div class="time" v-if="detail.qaCtime">{{detail.qaCtime | dateFilter}}</div>
        </div>
      </div>
      <div class="con">
        <div class="title">{{detail.qaQuestions}}</div>
        <div class="content" v-html="detail.qaAnswers"></div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import moment from 'moment'
import HomeHeader from "@/components/HomeHeader";
import Footer from "@/components/footer";

export default {
  name: "Home",
  components: {
    HomeHeader,
    Footer,
  },
  data() {
    return {
      detail: {}
    };
  },
  filters: {
    dateFilter(val) {
      return moment(+val).format('YYYY-MM-DD HH:mm')
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
  },
  mounted() {
    this.detail = this.$route.query.item
  },
}
</script>

<style lang="less" scoped>
.page{
  background-color: #F5F5F5;
}
.pageWrap{
  width: 1200px;
	min-height: 460px;
	background-color: #ffffff;
	border-radius: 4px;
  margin: 20px auto;
  padding: 20px 40px;
}
.top{
  border-bottom: solid 1px #e4e4e4;
  .back{
    color: #2A79FF;
    font-size: 16px;
    margin-bottom: 6px;
    cursor: pointer;
    width: 60px;
  }
  .info{
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #666;
    padding: 14px 0;
  }
}
.con{
  .title{
    font-size: 22px;
    color: #333;
    font-weight: 600;
    padding: 20px 0 10px;
  }
}


</style>